import React from 'react';
import styles from './DateRow.module.scss';
import { DatePicker, Form } from 'antd';
import moment from 'moment';
import {
  compareToCreateDate,
  compareToStartDate,
} from '../../lib/compareToDate';
import { permitConstants } from '../../../../../constants/permit.constants';

const DateRow = ({ form, permit, editingAcccess, isEdit }) => {
  const transportPermitTypeIdValue = form.getFieldValue(
    'transportPermitTypeId'
  );

  const hasDisposablePermit =
    transportPermitTypeIdValue === permitConstants.ONE_TIME_PASS; // Одноразовый пропуск

  const handleChangeStartDate = (value) => {
    if (hasDisposablePermit) {
      form.setFieldsValue({
        expireDate: moment(value).add(4, 'hours'),
      });
    }
  };

  return (
    <div className={styles.root}>
      <Form.Item label="Дата начала пропуска" style={{ margin: 0, flex: 1 }}>
        {form.getFieldDecorator('startDate', {
          initialValue: isEdit ? moment(permit?.startDate) : moment(),
          rules: [
            {
              required: true,
              message: 'Пожалуйста, укажите дату',
            },
            {
              validator: (rule, value, callback) => {
                const isSameDayAsOriginal =
                  isEdit &&
                  permit?.startDate &&
                  value &&
                  moment(permit.startDate).isSame(moment(value), 'day');

                if (isSameDayAsOriginal) {
                  callback();
                  return;
                }

                return compareToCreateDate(hasDisposablePermit)(
                  rule,
                  value,
                  callback
                );
              },
            },
          ],
        })(
          <DatePicker
            className={styles.customDate}
            format={hasDisposablePermit ? 'DD.MM.YYYY HH:mm' : 'DD.MM.YYYY'}
            placeholder="Введите дату"
            disabled={!editingAcccess}
            showTime={hasDisposablePermit ? { format: 'HH:mm' } : {}}
            onChange={handleChangeStartDate}
          />
        )}
      </Form.Item>
      <Form.Item label="Дата окончания пропуска" style={{ margin: 0, flex: 1 }}>
        {form.getFieldDecorator('expireDate', {
          initialValue:
            isEdit && permit?.expireDate ? moment(permit?.expireDate) : null,
          rules: [
            {
              required:
                transportPermitTypeIdValue === permitConstants.TEMPORARY_PASS,
              message: 'Пожалуйста, укажите дату',
            },
            { validator: compareToStartDate(form) },
          ],
        })(
          <DatePicker
            className={styles.customDate}
            format={hasDisposablePermit ? 'DD.MM.YYYY HH:mm' : 'DD.MM.YYYY'}
            placeholder="Введите дату"
            disabled={
              transportPermitTypeIdValue !== permitConstants.TEMPORARY_PASS ||
              !editingAcccess
            }
            showTime={hasDisposablePermit ? { format: 'HH:mm' } : {}}
          />
        )}
      </Form.Item>
    </div>
  );
};

export default DateRow;
